package com.partejar.app.feature.contratos.presentation

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.unit.IntSize
import kotlin.math.sqrt

internal data class SignaturePoint(val x: Float, val y: Float)

internal fun normalizedSignaturePoint(position: Offset, canvasSize: IntSize): SignaturePoint {
    if (canvasSize.width <= 0 || canvasSize.height <= 0) return SignaturePoint(0f, 0f)
    return SignaturePoint(
        x = (position.x / canvasSize.width).coerceIn(0f, 1f),
        y = (position.y / canvasSize.height).coerceIn(0f, 1f)
    )
}

internal fun appendSignaturePoint(
    stroke: List<SignaturePoint>,
    point: SignaturePoint,
    minimumDistance: Float = 0.001f
): List<SignaturePoint> {
    val previous = stroke.lastOrNull() ?: return listOf(point)
    val dx = point.x - previous.x
    val dy = point.y - previous.y
    return if (sqrt(dx * dx + dy * dy) >= minimumDistance) stroke + point else stroke
}

internal fun serializeSignatureStrokes(strokes: List<List<SignaturePoint>>): String =
    strokes.joinToString("|") { stroke ->
        stroke.joinToString(";") { point -> "${point.x},${point.y}" }
    }

internal fun canSubmitSignature(
    accepted: Boolean,
    strokes: List<List<SignaturePoint>>,
    submitting: Boolean = false
): Boolean = accepted && strokes.any { it.size > 1 } && !submitting
